import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    mode: null, // 'add' or 'edit',
    item: null
  },
  mutations: {
    INIT_UNIT_MNGT_DIALOG(state, payload) {
      state.visibility = true
      state.mode = payload.mode
      state.item = payload.item || null
    },
    SET_UNIT_MNGT_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_UNIT_MNGT_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.mode = null
        state.item = null
      }, 500)
    }
  },
  actions: {
    async addUnit({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.unit')),
          loading: true
        })
        commit('SET_UNIT_MNGT_DIALOG_SUBMIT_BTN_DISABLE', true)
        const response = await api.addUnit({ params: payload, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.unit')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_UNIT_MNGT_DIALOG')
          dispatch('fetchDirectory')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_UNIT_MNGT_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    },
    async updateUnit({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.unit')),
          loading: true
        })
        commit('SET_UNIT_MNGT_DIALOG_SUBMIT_BTN_DISABLE', true)
        const response = await api.updateUnit({ params: payload, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.update', Vuetify.locale.t('$vuetify.__InterfaceSetting.directory.unit')),
            icon: 'check',
            timeout: '2000'
          })
          commit('RESET_UNIT_MNGT_DIALOG')
          dispatch('fetchDirectory')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_UNIT_MNGT_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
